import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import industryIntegration from "../../images/v4/TgPages/marketting/customer.png";
import DesignCrmCarousel from "../../components/v4/designCarousel/DesignCarousel";
import salesReppageHerobg from "../../images/v4/TgPages/marketting/heroBg.png";
import salesCrmCarouselbg from "../../images/v4/TgPages/customerSupport/salesCrm.png";
import realWorldbg from "../../images/v4/salesReps/realWorld.svg";
import adaptImg1 from "../../images/v4/TgPages/marketting/adapt/img1.svg";
import adaptImg2 from "../../images/v4/TgPages/marketting/adapt/img2.svg";
import adaptImg3 from "../../images/v4/TgPages/marketting/adapt/img3.svg";
import adaptImg4 from "../../images/v4/TgPages/marketting/adapt/img4.svg";
import adaptImg5 from "../../images/v4/TgPages/marketting/adapt/img5.svg";
import adaptImg6 from "../../images/v4/TgPages/marketting/adapt/img6.svg";
import industryadaptbg from "../../images/v4/TgPages/marketting/client-garde.png";
import bussinessSuccessbg from "../../images/v4/salesReps/businessSuccessBg.png";
import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";
import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/salesReps/topcrm/zoho.png";
import compareItemImg3 from "../../images/v4/salesReps/topcrm/engage.png";
import compareItemImg4 from "../../images/v4/salesReps/topcrm/freshsale.png";
import compareItemImg5 from "../../images/v4/salesReps/topcrm/monday.png";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import realWorldImage1 from "../../images/v4/TgPages/marketting/realWorld/img1.png";
import realWorldImage2 from "../../images/v4/TgPages/marketting/realWorld/img2.png";
import realWorldImage3 from "../../images/v4/TgPages/marketting/realWorld/img3.png";
import realWorldImage4 from "../../images/v4/TgPages/marketting/realWorld/img4.png";
import realWorldImage5 from "../../images/v4/TgPages/marketting/realWorld/img5.png";
import broadcastImg1 from "../../images/v4/salesReps/Designfor/broadcast1.png";
import broadcastImg2 from "../../images/v4/salesReps/Designfor/broadcast2.png";
import broadcastImg3 from "../../images/v4/salesReps/Designfor/broadcast3.png";
import broadcastImg4 from "../../images/v4/salesReps/Designfor/broadcast4.png";
import broadcastImg5 from "../../images/v4/salesReps/Designfor/broadcast5.png";
import clientLogo1 from "../../images/v4/TgPages/marketting/clientImg/client1.png";
import clientLogo2 from "../../images/v4/TgPages/marketting/clientImg/client2.png";
import clientLogo3 from "../../images/v4/TgPages/marketting/clientImg/client3.png";
import clientLogo4 from "../../images/v4/TgPages/marketting/clientImg/client4.png";
import clientLogo5 from "../../images/v4/TgPages/marketting/clientImg/client5.png";
import clientLogo6 from "../../images/v4/TgPages/marketting/clientImg/client6.png";
import clientLogo7 from "../../images/v4/TgPages/marketting/clientImg/client7.png";
import tabImage1 from "../../images/v4/TgPages/marketting/tabImg/img1.png";
import tabImage2 from "../../images/v4/TgPages/marketting/tabImg/img2.png";
import tabImage3 from "../../images/v4/TgPages/marketting/tabImg/img3.png";
import tabImage4 from "../../images/v4/TgPages/marketting/tabImg/img4.png";
import tabImage5 from "../../images/v4/TgPages/marketting/tabImg/img5.png";
import tabrespImg1 from "../../images/v4/TgPages/marketting/tabImg/responssive/img1.png";
import tabrespImg2 from "../../images/v4/TgPages/marketting/tabImg/responssive/img2.png";
import tabrespImg3 from "../../images/v4/TgPages/marketting/tabImg/responssive/img3.png";
import tabrespImg4 from "../../images/v4/TgPages/marketting/tabImg/responssive/img4.png";
import tabrespImg5 from "../../images/v4/TgPages/marketting/tabImg/responssive/img5.png";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";
import imageScrollbg from "../../images/v4/TgPages/customerSupport/imageScroll.png";
import BanImg1 from "../../images/v4/TgPages/marketting/bannerImg/img1.png";
import BanImg2 from "../../images/v4/TgPages/marketting/bannerImg/img2.png";
import BanImg3 from "../../images/v4/TgPages/marketting/bannerImg/img3.png";
import BanImg4 from "../../images/v4/TgPages/marketting/bannerImg/img4.png";
import BanImg5 from "../../images/v4/TgPages/marketting/bannerImg/img5.png";
import BanImg6 from "../../images/v4/TgPages/marketting/bannerImg/img6.png";
import BanImg7 from "../../images/v4/TgPages/marketting/bannerImg/img7.png";
import BanImg8 from "../../images/v4/TgPages/marketting/bannerImg/img8.png";
import designbg from "../../images/v4/TgPages/designCrm.png";
import clientbg from "../../images/v4/TgPages/marketting/clientBg.png";
const useStyles = makeStyles((theme) => ({
  SalesRepSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${salesReppageHerobg})`,
    backgroundColor: "#210538",
    backgroundPosition: "center",
    "@media only screen and (max-width: 1440px)": {
      backgroundPosition: "top",
    },
  },
  salesRepContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "20px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "32px",
    "& h1": {
      margin: "0",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .bannerDescription": {},
  },
  aiSectionRight: {
    width: "50%",
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },

  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "100px",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "20px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "40px 0",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    maxWidth: "1200px",
    margin: "65px auto 24px",
    "& h2": {
      textAlign: "center",
    },

    "@media only screen and (max-width: 768px)": {
      margin: "45px 16px 24px",
      "& h2": {
        textAlign: "center",
        paddingRight: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& h2": {
        textAlign: "center",
      },
    },
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "18px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
      marginTop: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      marginTop: "25px",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
      marginTop: "20px",
      position: "relative",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "12px",
      marginTop: "15px",
    },
  },
  customerExperencesBox: {
    width: "32%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "50px",
    background: "#002c51",
    borderRadius: "15px",
    padding: "20px",
    minHeight: "230px",
    backdropFilter: "blur(30px) brightness(0.8)",
    overflow: "hidden",

    "& p:nth-child(2)": {
      color: "#D1E4F1",
    },
    "& p:last-child": {
      color: "#D1E4F1",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "31%",
      gap: "30px",
      padding: "18px",
      minHeight: "200px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "48%",
      gap: "25px",
      padding: "16px",
      minHeight: "180px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      padding: "15px",
      borderRadius: "20px",
      minHeight: "max-content",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      gap: "12px",
    },
    "&.orangeCard1": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard3": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard5": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard7": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard3": {
      background: "rgba(0, 154, 153, 0.4)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 50%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard0": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard2": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard4": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard6": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.greenCard7": {
      background: "#002C51",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #208EEC 50%, #002C51 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "6px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },
  Client: {
    background: " #011C33;",
    padding: "85px 0 40px",
    "& .client-carousel": {
      backgroundSize: "contain",
      backgroundImage: `url(${industryadaptbg})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
    "& .header": {
      display: "flex",
      width: "33%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .body": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "60px 0",
      "& .header": {
        width: "40%",
      },
      "& .body": {
        marginTop: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "60px 0 20px",
      "& .header": {
        width: "60%",
      },
      "& .body": {
        marginTop: "30px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      "& .body": {
        flexDirection: "column",
        flexWrap: "wrap",
        rowGap: "15px",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "streach",
      padding: "16px 8px",
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  integrationSection: {
    background: "linear-gradient(180deg, #011C33 0%, #451E66 100%)",
  },
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& div": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  combineSection: {
    position: "relative",
    backgroundImage: `url(${imageScrollbg})`,
    "@media only screen and (max-width: 768px)": {
      marginTop: "40px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      marginTop: "20px",
    },
  },
  adaptSlider: {
    padding: "15px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "20px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "18px",
      marginBottom: "16px",
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "16px",
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "14px",
      marginBottom: "12px",
    },
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "8px 16px",
    borderRadius: "25px",
    border: "1px solid #00B661",

    "& img": {
      width: "20px",
      height: "20px",
    },

    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  salesCrmCarousel: {
    backgroundImage: `url(${salesCrmCarouselbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "300px",
    position: "relative",
    "& .header-section": {
      flexDirection: "row",
      display: "flex",
      marginBottom: "64px",
      gap: "34px",

      "& h2": {
        width: "50%",
        color: "#fff",
      },
      "& p": {
        width: "50%",
        color: "#fff",
      },
      "@media(max-width:768px)": {
        width: "100%",
        flexDirection: "column",
        gap: "24px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "250px",
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "250px",
      "& .header": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "140px",
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },

  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  realWorldTabs: {
    backgroundImage: `url(${realWorldbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& h2": {
      textAlign: "center",
    },
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "280px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "170px",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        "& h2": {
          width: "100%",
        },
      },
    },
  },
  clientDetails: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
    "& .header": {
      "@media only screen and (max-width: 768px)": {
        textAlign: "center",
        "& p": {
          width: "100%",
        },
      },
    },
  },
  adaptsBox: {
    gap: "24px",
    display: "flex!important",
    padding: "24px",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    borderRadius: "16px",
    height: "auto!important",
    flex: "0 0 31.7%",
    "& p": {
      color: "#fff",
    },
    "@media (max-width:1100px)": {
      flex: "0 0 47%",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "20px",
      maxWidth: "350px",
      gap: "14px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "18px",
      maxWidth: "320px",
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
      flex: "0 0 100%",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      maxWidth: "85%",
      gap: "10px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 1024px)": {
      minHeight: "70px",
    },
    "@media only screen and (max-width: 768px)": {
      minHeight: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
      minHeight: "auto",
    },
    "@media only screen and (max-width: 480px)": {
      minHeight: "auto",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
    "@media only screen and (max-width: 1024px)": {
      width: "44px",
      maxWidth: "44px",
      marginBottom: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "40px",
      maxWidth: "40px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "36px",
      maxWidth: "36px",
      marginBottom: "16px",
    },
    "@media only screen and (max-width: 480px)": {
      width: "32px",
      maxWidth: "32px",
      marginBottom: "14px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
      width: "100%",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },
  broadcastBox: {
    padding: "32px 32px 0",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0 auto",

    "& img": {
      maxWidth: "80%",
      width: "auto",
      height: "auto",
      margin: "24px auto 0",
      display: "table",
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "auto",
      },
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "90%",
        height: "auto",
      },
    },
  },
  designCrmCarousel: {
    backgroundImage: `url(${designbg})`,
    "& .designHeader": {
      maxWidth: "55%",
      "& h2": {
        marginBottom: "24px",
      },
      "& p": {
        marginBottom: "16px",
        fontSize: "20px",
      },
      "@media(max-width:768px)": {
        maxWidth: "100%",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
      "& .swiper-slide": {
        height: "auto!important",
      },
    },
    "@media(max-width:768px)": {
      "& .swiper-wrapper": {
        padding: "0 24px ",
      },
    },
    ".swiper-slide": {
      width: "100%!important",
    },
  },
  broadcastContainerInner: {
    display: "flex",
    flexDirection: "column-reverse",
    paddingBottom: "86px",
    "@media(max-width:1024px)": {
      padding: "0 50px 32px!important",
    },
    "@media(max-width:600px)": {
      padding: "0 0 32px!important",
    },
    "& .swiper-button-prev": {
      top: "100px !important",
      left: "auto",
      right: "200px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
    "& .swiper-button-next": {
      top: "100px !important",
      right: "100px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
  },
  faqBoxAccordian: {
    padding: "24px",
    backgroundColor: "#f8fcff",
    borderRadius: "16px",
    "&.active": {
      backgroundImage: " linear-gradient(89deg, #e0effd 4%, #e0fafa 100%)",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#F1FFFE",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
  salesCard: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "28px",
  },
}));

const tabContentData = [
  {
    tabContent: [
      {
        heading: "Lead qualification automation",
        content:
          "Score and route leads based on user behaviour and firmographics.",
        alt: "Lead qualification automation",
      },
      {
        heading: "Lifecycle campaigns",
        content:
          "Nurture prospects with tailored onboarding and educational sequences.",
        alt: "Lifecycle campaigns",
      },
      {
        heading: "ROI tracking",
        content:
          "Monitor campaign conversion rates and optimise based on real-time data.",
        alt: "ROI tracking",
      },
      {
        heading: "Sales alignment",
        content: "Share lead readiness and interaction history in real time.",
        alt: "Sales alignment",
      },
    ],
    image: realWorldImage1,
    alt: "CRM for B2B SaaS Marketing Teams",
    subtitle:
      "Marketing teams in B2B SaaS can drive lead generation and engagement with campaign automation, segmentation, and real-time performance analysis.",
  },
  {
    tabContent: [
      {
        heading: "Client onboarding automation",
        content:
          "Simplify intake forms, briefing processes, and contract collection.",
        alt: "Client onboarding automation",
      },
      {
        heading: "Project tracking",
        content:
          "Monitor timelines, revisions, and approvals in a shared dashboard.",
        alt: "Project tracking",
      },
      {
        heading: "Team-client coordination",
        content:
          "Align agency teams and clients with transparent task visibility.",
        alt: "Team-client coordination",
      },
      {
        heading: "Retention monitoring",
        content:
          "Detect inactive clients and automate personalised re-engagement efforts.",
        alt: "Retention monitoring",
      },
    ],
    image: realWorldImage2,
    alt: "CRM for Digital Marketing Agencies",
    subtitle:
      "Pepper Cloud is the best CRM for digital marketing agencies, streamlining campaign tracking, client communications, and centralised data management.",
  },
  {
    tabContent: [
      {
        heading: "Customer segmentation",
        content: "Group buyers by behaviour, preferences, and order history.",
        alt: "Customer segmentation",
      },
      {
        heading: "Automated cart recovery",
        content: "Send reminders and offers to recover lost sales.",
        alt: "Automated cart recovery",
      },
      {
        heading: "Personalised promotions",
        content: "Deliver timely offers via email, WhatsApp, or SMS.",
        alt: "Personalised promotions",
      },
      {
        heading: "Loyalty campaign triggers",
        content: "Offer exclusive deals based on loyalty tier.",
        alt: "Loyalty campaign triggers",
      },
    ],
    image: realWorldImage3,
    alt: "CRM for E-commerce Marketing Teams",
    subtitle:
      "CRM helps e-commerce marketers improve targeting, personalise campaigns, and drive repeat purchases by unifying customer data across touchpoints.",
  },
  {
    tabContent: [
      {
        heading: "Enquiry automation",
        content: "Capture and respond to student queries instantly.",
        alt: "Enquiry automation",
      },
      {
        heading: "Campaign nurturing",
        content:
          "Send course details, deadlines, and reminders based on interest.",
        alt: "Campaign nurturing",
      },
      {
        heading: "Engagement tracking",
        content:
          "Measure open rates, content interactions, and application conversions.",
        alt: "Engagement tracking",
      },
      {
        heading: "Personalised follow-ups",
        content: "Use behaviour data to time counsellor callbacks.",
        alt: "Personalised follow-ups",
      },
    ],
    image: realWorldImage4,
    alt: "CRM for Educational Institutions",
    subtitle:
      "Universities and edtech providers use CRM to automate admissions, nurture leads, and analyse student engagement across campaigns and outreach efforts.",
  },
  {
    tabContent: [
      {
        heading: "Registration workflows",
        content:
          "Capture sign-ups and auto-send confirmations or calendar invites.",
        alt: "Registration workflows",
      },
      {
        heading: "Reminder automation",
        content: "Schedule email or WhatsApp reminders before the event.",
        alt: "Reminder automation",
      },
      {
        heading: "Attendee segmentation",
        content: "Group contacts by interest, behaviour, or attendance status.",
        alt: "Attendee segmentation",
      },
      {
        heading: "Post-event follow-ups",
        content: "Trigger personalised thank-yous, feedback forms, and offers.",
        alt: "Post-event follow-ups",
      },
    ],
    image: realWorldImage5,
    alt: "CRM for Event and Webinar Marketers",
    subtitle:
      "Marketing teams managing virtual or in-person events can use CRM to automate registrations, nurture attendees, and track engagement across the full event lifecycle.",
  },
];
const tabData = [
  {
    label: "Unify campaigns",
    title: "Unify marketing campaigns ",
    desc: "Fragmented tools make it difficult to track performance and optimise campaigns. Pepper Cloud CRM centralises marketing activities, lead journeys, and engagement metrics, giving your team the clarity and control needed to turn strategic insights into measurable, scalable results.",
    bgcolor: "purple",
    img: tabImage1,
    respImg: tabrespImg1,
  },
  {
    label: "Automate tasks",
    title: "Automate tasks, save more time",
    desc: "Pepper Cloud CRM automates routine marketing actions like message broadcasts, follow-ups, and more. Your team gains back valuable hours to focus on campaign strategy, while automation ensures faster, more consistent lead engagement and conversions.",
    bgcolor: "green",
    img: tabImage2,
    respImg: tabrespImg2,
  },
  {
    label: "Customise",
    title: "Customise for your business",
    desc: "Design your pipeline to fit your marketing strategy by creating, renaming, and organising stages as needed. Collect specific customer information with custom fields and manage deals in various currencies that meet your unique business needs.",
    bgcolor: "lightBlueBg",
    img: tabImage3,
    respImg: tabrespImg3,
  },
  {
    label: "Engage customers",
    title: "Engage customers through live chat",
    desc: "Enhance your marketing strategy by adding a chat widget to your website. Offer round-the-clock support and interact with visitors based on their browsing behaviour. Route inquiries to the right team members and gather valuable lead information using integrated lead capture forms.",
    bgcolor: "darkBlue",
    img: tabImage4,
    respImg: tabrespImg4,
  },
  {
    label: "Turn insights",
    title: "Turn insights into marketing strategy",
    desc: "Pepper Cloud marketing CRM gives your team access to real-time campaign performance data through visual dashboards. Understand lead behaviour, campaign effectiveness, and content engagement. Use these insights to fine-tune messaging, optimise spend, and align your marketing strategy with measurable business outcomes.",
    bgcolor: "lightPurple",
    img: tabImage5,
    respImg: tabrespImg5,
  },
];
// card data

const MarketingTeams = () => {
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  // cards animation

  useEffect(() => {
    const cards = document.querySelectorAll(".card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;
          const currentIndex = Array.from(cards).indexOf(card);

          if (entry.isIntersecting) {
            // Remove all previous classes first
            cards.forEach((c) => {
              c.classList.remove(
                "is-previous-1",
                "is-previous-2",
                "is-previous-3",
                "is-previous-4"
              );
            });

            // Add appropriate classes based on distance from current card
            cards.forEach((c, index) => {
              if (index < currentIndex) {
                const difference = currentIndex - index;
                if (difference <= 4) {
                  // Only apply effects to 4 cards back
                  c.classList.add(`is-previous-${difference}`);
                }
              }
            });
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
        rootMargin: "0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  // tab data
  const [activeTab, setActiveTab] = useState(tabData[0]);

  const activeContent = tabData.find((tab) => tab.label === activeTab.label);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const classes = useStyles();

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard3`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard2`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard0`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard4`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard6`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard1`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard5`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard7`
      ),
    ];

    const setupCard = (card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150;
        const topRightY = 0;

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      card.handlers = handlers;

      card.addEventListener("mousemove", handlers.mousemove);
      card.addEventListener("mouseenter", handlers.mouseenter);
      card.addEventListener("mouseleave", handlers.mouseleave);
      window.addEventListener("resize", handlers.resize);
    };

    cardsToAnimate.forEach(setupCard);

    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card?.handlers) return;

        const { handlers } = card;
        card.removeEventListener("mousemove", handlers.mousemove);
        card.removeEventListener("mouseenter", handlers.mouseenter);
        card.removeEventListener("mouseleave", handlers.mouseleave);
        window.removeEventListener("resize", handlers.resize);
      });
    };
  }, [classes]);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    if (typeof window === "undefined") return; // Prevent SSR errors

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        if (!this.track) return; // safety check
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Duplicate content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        if (logos.length === 0) return;

        let totalWidth = 0;
        logos.forEach((logo) => {
          const style = getComputedStyle(logo);
          totalWidth +=
            logo.offsetWidth +
            parseInt(style.marginLeft) +
            parseInt(style.marginRight);
        });

        // Set row height
        const firstLogoStyle = getComputedStyle(logos[0]);
        this.row.style.height =
          logos[0].offsetHeight +
          parseInt(firstLogoStyle.marginTop) +
          parseInt(firstLogoStyle.marginBottom) +
          "px";

        // Initial position
        this.oneThirdWidth = -this.track.offsetWidth / 3;
        this.position = this.direction === "left" ? 0 : this.oneThirdWidth;

        // Start animation
        this.animate();
      }

      animate() {
        const loop = () => {
          if (this.direction === "left") {
            this.position -= this.speed;
            if (this.position <= this.oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            if (this.position >= 0) {
              this.position = this.oneThirdWidth;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(loop);
        };

        requestAnimationFrame(loop);
      }
    }

    // Initialize all rows
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const bannerlogotrack2 = [
    { img: BanImg1, alt: "Send messages and track response rate" },
    { img: BanImg2, alt: "Marketing campaign ad creative managed with Pepper Cloud CRM" },
    { img: BanImg3, alt: "Pepper Cloud CRM marketing for managing campaigns, leads, and customer interactions" },
    { img: BanImg4, alt: "Run Marketing campaigns with Pepper Cloud" },
  ];
  const bannerlogotrack3 = [
    { img: BanImg5, alt: "Run Add campaigns for footwear industry with Pepper Cloud" },
    { img: BanImg6, alt: "Run campaigns on Shopify with Pepper Cloud" },
    { img: BanImg7 },
    { img: BanImg8, alt: "Run summer campaign and track leads" },
  ];

  useEffect(() => {
    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".banner-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "top";
        if (this.track) {
          this.init();
        }
      }

      init() {
        // Store original children so we always clone from a clean copy
        const originalItems = Array.from(this.track.children).map((child) =>
          child.cloneNode(true)
        );
        if (!originalItems.length) return;

        const containerHeight = this.row.offsetHeight;
        let currentHeight = this.track.offsetHeight;

        // Fill until track height is at least twice container height
        while (currentHeight < containerHeight * 2) {
          originalItems.forEach((clone) => {
            this.track.appendChild(clone.cloneNode(true));
          });
          currentHeight = this.track.offsetHeight;
        }

        // Set initial scroll position
        if (this.direction === "top") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetHeight / 2;
        }

        this.animate();
      }

      animate() {
        const animateStep = () => {
          if (this.direction === "top") {
            this.position -= this.speed;
            if (this.position <= -this.track.offsetHeight / 2) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            if (this.position >= 0) {
              this.position = -this.track.offsetHeight / 2;
            }
          }
          this.track.style.transform = `translateY(${this.position}px)`;
          requestAnimationFrame(animateStep);
        };

        requestAnimationFrame(animateStep);
      }
    }

    if (typeof window !== "undefined") {
      document.querySelectorAll(".logos-row").forEach((row) => {
        const speed = parseFloat(row.dataset.speed) || 0.5;
        new InfiniteScroll(row, speed);
      });
    }
  }, []);

  // client

  const allIconsclient = [
    {
      img: clientLogo1,
    },
    {
      img: clientLogo2,
    },
    {
      img: clientLogo3,
    },
    {
      img: clientLogo4,
    },
    {
      img: clientLogo5,
    },
    {
      img: clientLogo6,
    },
    {
      img: clientLogo7,
    },
  ];

  // Function to distribute icons across three tracks
  function clientdistributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) => a.img.localeCompare(b.img));

    const clientlogotrack1 = [];
    const clientlogotrack2 = [];
    const clientlogotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          clientlogotrack1.push(icon);
          break;
        case 1:
          clientlogotrack2.push(icon);
          break;
        case 2:
          clientlogotrack3.push(icon);
          break;
      }
    });

    return {
      clientlogotrack1,
      clientlogotrack2,
      clientlogotrack3,
    };
  }

  // Get the distributed icons
  const { clientlogotrack1, clientlogotrack2, clientlogotrack3 } =
    clientdistributeIcons(allIconsclient);

  useEffect(() => {
    if (typeof window === "undefined") return; // Skip SSR

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row?.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row?.dataset?.direction || "left";
        if (this.track) {
          this.init();
        }
      }

      init() {
        // Clone the content safely
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Get all logos
        const logos = this.track.querySelectorAll(".logo");
        if (logos.length === 0) return;

        // Calculate total width
        let totalWidth = 0;
        logos.forEach((logo) => {
          const style = getComputedStyle(logo);
          totalWidth +=
            logo.offsetWidth +
            parseInt(style.marginLeft) +
            parseInt(style.marginRight);
        });

        // Set row height
        this.row.style.height = `${logos[0].offsetHeight}px`;

        // Set initial position
        this.position =
          this.direction === "left" ? 0 : -this.track.offsetWidth / 3;

        // Start animation
        this.animate();
      }

      animate() {
        const loop = () => {
          if (!this.track) return;

          if (this.direction === "left") {
            this.position -= this.speed;
            if (this.position <= -this.track.offsetWidth / 3) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(loop);
        };

        requestAnimationFrame(loop);
      }
    }

    // Wait until DOM is ready and elements are in place
    const rows = document.querySelectorAll(".logos-row");
    if (rows.length > 0) {
      rows.forEach((row) => {
        const speed = parseFloat(row.dataset.speed) || 1;
        new InfiniteScroll(row, speed);
      });
    }
  }, []);

  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollPosition(currentScrollY);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // setSubMenuOpen(false);
        // setIsVisible(false);
      } else {
        // setSubMenuOpen(false);
        // setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // client

  const benifitList = [
    {
      img: industryIntegration,
      title: "Why marketing teams need a CRM to boost ROI",
      desc: "Marketing teams manage campaigns, track performance, and engage leads across channels, all while aligning with sales to drive revenue. Without a unified system, data becomes fragmented, and results are harder to measure. A robust CRM system for the marketing team centralises audience insights, campaign metrics, and sales activities. This enables better segmentation, smarter decisions, and faster conversions, making CRM software for marketing team operations critical to driving scalable, measurable growth.",
    },
  ];

  const faqs = [
    {
      question: "What makes Pepper Cloud the best CRM for a marketing team?",
      answer: (
        <>
          Pepper Cloud brings together campaign tracking, lead segmentation,
          marketing automation, and real-time sales collaboration, making it the
          ideal choice for growing teams that need performance and scalability
          without added complexity.
        </>
      ),
    },
    {
      question: "How to use CRM for marketing?",
      answer: (
        <>
          Start by centralising your lead data, then segment audiences, automate
          outreach, and track campaign performance. Pepper Cloud simplifies
          every step, so you can focus on converting leads and refining your
          marketing strategy.
        </>
      ),
    },
    {
      question: "Can sales and marketing use the same CRM?",
      answer: (
        <>
          Yes. Pepper Cloud CRM is designed to align both teams. It offers
          shared dashboards, lead status updates, and real-time collaboration to
          ensure no opportunity is missed during the handoff.
        </>
      ),
    },
    {
      question: "Which CRM is best for marketing campaigns?",
      answer: (
        <>
          The best CRM for marketing campaigns is one that enables segmentation,
          automation, and tracking. Pepper Cloud offers all three, plus seamless
          integration with sales for complete funnel visibility.
        </>
      ),
    },
    {
      question:
        "What are the top features of CRM software for the marketing team?",
      answer: (
        <>
          Top features include campaign tracking, lead scoring, audience
          segmentation, marketing automation, and sales collaboration. Pepper
          Cloud offers all of these in a scalable, easy-to-use platform for
          SMEs.
        </>
      ),
    },
    {
      question: "Why do marketers need a CRM system?",
      answer: (
        <>
          A CRM system helps marketers manage leads, personalise engagement, and
          measure ROI. It enables better decisions, faster campaigns, and
          improved alignment with sales for higher conversions.
        </>
      ),
    },
    {
      question:
        "What are the advantages and disadvantages of CRM for marketing?",
      answer: (
        <>
          <strong>Advantages:</strong>
          <ul>
            <li>Centralised lead and campaign data</li>
            <li>Enhanced targeting and personalisation</li>
            <li>Marketing-sales alignment</li>
            <li>Automation of repetitive tasks</li>
            <li>Improved visibility into performance</li>
          </ul>
          <strong>Disadvantages (if not selected wisely):</strong>
          <ul>
            <li>Overly complex tools may cause low adoption</li>
            <li>Lack of integration can create silos</li>
            <li>Costs can vary based on features</li>
          </ul>
          Pepper Cloud solves these by offering a simple, scalable CRM with
          expert support and seamless integrations—built for fast-moving
          marketing teams.
        </>
      ),
    },
    {
      question: "What is marketing automation in CRM?",
      answer: (
        <>
          Marketing automation in CRM refers to using automated workflows to
          manage repetitive marketing tasks, such as sending emails, segmenting
          leads, scheduling follow-ups, and scoring prospects based on user
          behaviour or defined triggers. It helps teams scale outreach, improve
          efficiency, and deliver more personalised experiences.
        </>
      ),
    },
  ];

  const adaptList = [
    {
      pointer: "Lead segmentation",
      desc: "Group contacts by behaviour, source, or intent to run targeted campaigns and boost engagement across every channel.",
      img: adaptImg1,
      alt: "Faster response times in CRM for support teams",
    },
    {
      pointer: "Campaign tracking",
      desc: "Monitor ad campaign performance and email responses in real time to make faster, data-backed marketing decisions.",
      img: adaptImg2,
      alt: "Personalised customer interactions in CRM",
    },
    {
      pointer: "Workflow automation",
      desc: "Streamline follow-ups, email drips, and reminders to save time and increase lead-nurturing efficiency.",
      img: adaptImg3,
      alt: "Collaboration tools in CRM for support teams",
    },
    {
      pointer: "Sales alignment",
      desc: "Bridge the gap with sales by capturing leads, assigning tasks, and ensuring timely follow-ups.",
      img: adaptImg4,
      alt: "Cross-channel customer support in CRM",
    },
    {
      pointer: "Engagement insights",
      desc: "Analyse clicks, form fills, and downloads to optimise your messaging and content strategy.",
      img: adaptImg5,
      alt: "CRM analytics and reporting for support teams",
    },
    {
      pointer: "Scalable CRM",
      desc: "A flexible solution built for growing businesses, with features that adapt as your team and goals evolve.",
      img: adaptImg6,
      alt: "Scalable CRM for growing customer support needs",
    },
  ];

  // sales rep contents
  const bannerPoints = [
    "Campaign tracking",
    "Lead segmentation",
    "Workflow automation",
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot ",
    "Zoho CRM",
    "ActiveCampaign ",
    "Pipedrive",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "The best CRM for marketing teams, Pepper Cloud, offers multiple CRM features for marketing that help you automate campaigns, track performance, and align with sales, all in a user-friendly interface. Pepper Cloud is ideal for marketers who need visibility, control, and growth without complexity.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Auto-capture leads details",
          desc: "Automatically capture leads from website, WhatsApp ads, and more. Track lead capture source effortlessly.",
        },
        {
          title: "Email marketing tool integration",
          desc: "Integrate with tools like Mailchimp and MailerLite, and access campaign performance data directly in the CRM.",
        },
        {
          title: "Lead segmentation",
          desc: "Segment audiences based on behaviour and intent using colourful tags.",
        },
        {
          title: "Marketing automation",
          desc: "Automate drip campaigns, follow-ups, and chatflows using AI-powered chatbot and workflow automation.",
        },
        {
          title: "Multichannel CRM",
          desc: "Connect via messaging channels, email inboxes, and more to offer multi-channel communication to leads.",
        },
        {
          title: "Sales alignment",
          desc: "Share lead insights and sync handovers seamlessly with your sales team.",
        },
      ],
    },
    {
      title: "HubSpot",
      desc: "HubSpot CRM offers inbound marketing tools with automation features for growing businesses.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Email marketing",
          desc: "Create and automate personalised email campaigns.",
        },
        {
          title: "Lead capture",
          desc: "Use forms, CTAs, and landing pages to capture and manage leads.",
        },
        {
          title: "Campaign analytics",
          desc: "Track conversions and engagement from a central dashboard.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM helps marketing teams manage campaigns, nurture leads, and integrate workflows with sales.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Campaign management",
          desc: "Run and analyse multi-channel marketing campaigns.",
        },
        {
          title: "Workflow rules",
          desc: "Automate follow-ups and lead routing for better efficiency.",
        },
        {
          title: "Reporting",
          desc: "Create detailed campaign and lead performance reports.",
        },
      ],
    },
    {
      title: "ActiveCampaign",
      desc: "A CRM focused on marketing automation and customer experience.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Email sequences",
          desc: "Set up multi-step automation flows for targeted engagement.",
        },
        {
          title: "Behavioural triggers",
          desc: "Send messages based on user actions and engagement patterns.",
        },
        {
          title: "CRM integration",
          desc: "Sync with your sales CRM to align marketing and sales efforts.",
        },
      ],
    },
    {
      title: "Pipedrive",
      desc: "Pipedrive supports lead tracking with add-ons for marketing workflows.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Visual pipelines",
          desc: "View leads clearly in each funnel stage for better management.",
        },
        {
          title: "Add-on campaigns",
          desc: "Manage email campaigns with third-party integrations.",
        },
        {
          title: "Metrics tracking",
          desc: "Analyse conversions and campaign performance with ease.",
        },
      ],
    },
  ];
  const broadcastList = [
    {
      pointer: "CRM for sales managers",
      card: {
        pointer: [
          "Track sales performance, coach teams better, and scale revenue with real-time insights and reports.",
        ],
        img: broadcastImg1,
        alt: "Create whatsapp broadcast list",
        backgroundColor: "#f48446",
        backgroundImage: "linear-gradient(to bottom, #f48446, #783ca8)",
      },
    },
    {
      pointer: "CRM for sales development reps",
      card: {
        pointer: [
          "Qualify leads, automate outreach, and book meetings faster with integrated calling and task tools.",
        ],
        img: broadcastImg2,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: "#014957",
        backgroundImage: "linear-gradient(to bottom, #014957, #028ba6)",
      },
    },
    {
      pointer: "CRM for marketing teams",
      card: {
        pointer: [
          "Launch campaigns and capture more leads with ease while tracking performance in real-time and managing all campaign activities.",
        ],
        img: broadcastImg3,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: " #31114b",
        backgroundImage: "linear-gradient(to bottom, #31114b, #783ca8);",
      },
    },
    {
      pointer: "CRM for customer support teams",
      card: {
        pointer: [
          "Respond faster, manage tickets efficiently, and improve satisfaction with smart support workflows.",
        ],
        img: broadcastImg4,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#2788e7",
        backgroundImage: "linear-gradient(to bottom, #2788e7, #783ca8)",
      },
    },
    {
      pointer: "CRM for business owners",
      card: {
        pointer: [
          "Gain full visibility and control from one platform with real-time insights, revenue trends, and business growth metrics.",
        ],
        img: broadcastImg5,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#09939a",
        backgroundImage: " linear-gradient(to bottom, #09939a, #783ca8)",
      },
    },
  ];
  const tabs = [
    "Human-centric",
    "Custom ticketing",
    "Fast onboarding",
    "Multi-channel",
    "Performance",
  ];
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <main>
      <SEO
        description={
          "Discover the best CRM for marketing team performance. Automate campaigns, track leads, and align with sales using Pepper Cloud CRM—built for growing businesses."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords=" crm marketing,best marketing crm software, crm marketing features, crm feature for marketing, crm software for marketing team, how to use crm for marketing"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={"Best CRM for marketing team | boost campaign results"}
      />

      <section className={classes.SalesRepSection}>
        <div className="carouselContainer">
          <div className={classes.salesRepContainer}>
            <div className={classes.salesSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64 font-white "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Best CRM for marketing teams
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  font-white bannerDescription"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Manage campaigns, collaborate with the sales team, generate more
                qualified leads, and boost ROI faster with the best marketing
                CRM.
              </motion.p>
              <div className={classes.bannerPoint}>
                {bannerPoints.map((point) => (
                  <div className={classes.banerPointItem}>
                    <img src={bannerTick} />
                    <motion.p
                      className="font-wix-regular font-18 font-white"
                      key={`banner-point-${point}`}
                    >
                      {point}
                    </motion.p>
                  </div>
                ))}
              </div>

              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <div className="parallax-container">
              <section className="banner-carousel">
                <div className="banner-container">
                  <div className="scroll-container">
                    <div
                      className="logos-row"
                      data-direction="top"
                      data-speed="0.8"
                    >
                      <div className="banner-track">
                        {bannerlogotrack2.map((icon, index) => (
                          <div className="logo font-18 font-wix-medium">
                            <img key={index} src={icon.img} alt={icon.alt} />
                          </div>
                        ))}
                      </div>
                    </div>

                    <div
                      className="logos-row"
                      data-direction="bottom"
                      data-speed="0.4"
                    >
                      <div className="banner-track">
                        {bannerlogotrack3.map((icon, index) => (
                          <div className="logo font-18 font-wix-medium">
                            <img key={index} src={icon.img} alt={icon.alt} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.Client}>
        <div className="container">
          <div className={classes.clientDetails}>
            <div className="header">
              <motion.h2
                className="font-wix-semibold font-56 colorWhite"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Trusted by top brands across industries
              </motion.h2>
            </div>
            <div className="client-carousel dark">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {clientlogotrack1.map((logo) => (
                        <div
                          className="logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {clientlogotrack2.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {clientlogotrack3.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {benifitList.map((benifit) => (
        <section className={classes.integrationSection}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <motion.div
                className={classes.integrationRight}
                initial={{ opacity: 0, y: -50 }} // top to bottom
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <img
                  alt={benifit.title}
                  className={classes.integrationRightImage}
                  src={benifit.img}
                />
              </motion.div>

              <motion.div
                className={classes.integrationLeft}
                initial={{ opacity: 0, y: 50 }} // bottom to top
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <motion.h2
                  className="font-wix-semibold font-56 font-white"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, ease: "easeOut", delay: 0.1 }}
                  viewport={{ once: true }}
                >
                  {benifit.title}
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 font-white mt20"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, ease: "easeOut", delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {benifit.desc}
                </motion.p>
              </motion.div>
            </div>
          </div>
        </section>
      ))}
      <section className="crmSection">
        <div className="container">
          <h2 className="font-wix-semibold font-56 color-black1">
            CRM marketing features that drive ROI
          </h2>
          <div className="tab-component">
            <div className="tabContainer">
              {tabData.map((tab) => {
                const isActive = activeTab.label === tab.label;

                return (
                  <div
                    key={tab.label}
                    className={`tab font-16 font-wix-semibold ${tab.bgcolor} ${
                      isActive ? "activeTab" : ""
                    }`}
                    onClick={() => setActiveTab(tab)}
                    animate={{
                      scale: isActive ? 1.05 : 1,
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  >
                    {tab.label}
                  </div>
                );
              })}
            </div>

            {/* contentBox animation */}
            <div className={`contentBox ${activeTab.bgcolor}`}>
              <div className="imageBox">
                {/* image animation */}
                <motion.img
                  key={activeTab.img} // ensures animation triggers on change
                  src={activeTab.img}
                  alt={activeTab.title}
                  initial={{ y: -50, opacity: 0 }} // starts 50px above
                  animate={{ y: 0, opacity: 1 }} // moves to normal position
                  transition={{ duration: 0.6, ease: "easeOut" }}
                />
              </div>
              <div className="textBox">
                <motion.div
                  key={activeTab.label}
                  initial={{ y: 50, opacity: 0 }} // starts 50px above
                  animate={{ y: 0, opacity: 1 }} // moves to normal position
                  transition={{ duration: 0.6, ease: "easeOut" }}
                >
                  <h3>{activeTab.title}</h3>
                  <p>{activeTab.desc}</p>
                </motion.div>
              </div>
            </div>
          </div>
        </div>

        <div className="responssive-cards">
          <ul id="cards">
            {tabData.map((data, index) => (
              <li className="card" id={`card-${index + 1}`}>
                <div className={`card-content ${data.bgcolor}`}>
                  <div className="cardContentData">
                    <h3 className="cardHeading font-wix-medium">
                      {data.title}
                    </h3>
                    <p className="cardDesciption">{data.desc}</p>
                  </div>
                  <div className="cardImg">
                    <motion.img
                      key={data.respImg} // ensures animation triggers on change
                      src={data.respImg}
                      alt={data.title}
                    />
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="header-section">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              What marketing teams expect from their CRM
            </motion.h2>
            <motion.p
              className="font-wix-regular font-18 color-black2"
              initial={{ opacity: 1, y: -20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Marketing teams need more than just contact storage, they need
              insights, automation, and real-time coordination with sales.
              Pepper Cloud delivers powerful features that help marketers work
              smarter, personalise engagement, and maximise campaign ROI.
            </motion.p>
          </div>
          <div className={classes.salesCard}>
            {adaptList.map((point, index) => (
              <motion.div
                className={classes.adaptsBox}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.2 }}
              >
                <div className={classes.adaptBoxHeader}>
                  <img
                    className={classes.adaptBoxImg}
                    src={point.img}
                    alt={point.pointer}
                  />
                  <p className="font-24 font-wix-semibold lineHeight-1">
                    {point.pointer}
                  </p>
                </div>
                <div className={classes.adaptDescription}>
                  <p className="font-wix-regular font-18">{point.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>

      <section className={classes.realWorldTabs}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Application and use cases of CRM for marketing team
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                B2B SaaS companies
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                 Digital marketing
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                E-commerce
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Educational
              </div>

              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 4 && "active"
                )}
                onClick={() => setActiveRealWorld(4)}
              >
                Event and webinar
              </div>
            </div>
          </div>

          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        className="font-wix-regular font-18 color-black2"
                        initial={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            className={classes.benfitListItem}
                            initial={{ opacity: 0, y: 20 }}
                            transition={{ duration: 0.3 }}
                            whileInView={{ opacity: 1, y: 0 }}
                          >
                            <LazyImage
                              alt={item.alt}
                              className={classes.benfitIcon}
                              source={bannerTick}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-18 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        alt={listItem.alt}
                        source={listItem.image}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>

      <section className={classes.combineSection}>
        <div className={classes.bussinessSuccessContainer}>
          <div className={classes.integrationHeaderItem}>
            <div className={classes.integrationContent}>
              <motion.h2
                className="font-wix-semibold font-56 color-black7"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Tailored for business success
              </motion.h2>
            </div>
          </div>

          <section className="support-logo-carousel">
            <div className="logos-container">
              <div className="scroll-container">
                <div
                  className="logos-row"
                  data-direction="left"
                  data-speed="0.8"
                >
                  <div className="logos-track">
                    {logotrack1.map((logo) => (
                      <div
                        className="logo font-18 font-wix-medium"
                        key={logo.title}
                      >
                        <img alt={`${logo.title} integration`} src={logo.img} />
                        <p>{logo.title}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  className="logos-row"
                  data-direction="right"
                  data-speed="0.4"
                >
                  <div className="logos-track">
                    {logotrack2.map((logo) => (
                      <div className="logo font-18 font-wix-medium">
                        <img alt={`${logo.title} integration`} src={logo.img} />
                        <p>{logo.title}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
      <div className="container">
        <div className="header">
          <motion.h2
            className="font-wix-semibold font-56 font-black1"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Top 5 best CRM marketing software in 2025
          </motion.h2>
        </div>
        <div className={classes.compareSectionContainer}>
          <div className={classes.compareSectionContainerLeftSection}>
            {compareItems.map((item, index) => (
              <div
                className={clsx(
                  classes.compareSectionLeftItem,
                  activeCompare === `#section${index}` && "active"
                )}
                onClick={() => {
                  scrollToSection(`#section${index}`);
                  setActiveCompare(`#section${index}`);
                }}
              >
                <a
                  className={clsx(
                    "font-22 font-wix-medium font-black1",
                    activeCompare === `#section${index}` && "font-wix-semibold"
                  )}
                  href={`#section${index}`}
                >
                  {item}
                </a>
              </div>
            ))}
          </div>
          <div className={classes.compareSectionContainerRightSection}>
            {compareData.map((data, outerIndex) => (
              <div
                className={classes.compareItemContainer}
                id={`#section${outerIndex}`}
              >
                <h3
                  className="font-40 font-wix-semibold font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.title}
                </h3>
                <p
                  className="font-wix-regular font-18 font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.desc}
                </p>
                <img alt={data.alt} className="productImage" src={data.img} />
                <div className={classes.faqsContainer}>
                  {data.features.map((faq, innerIndex) => (
                    <motion.div
                      className={classes.faqBox}
                      onClick={() =>
                        setActiveAccordian(
                          `${outerIndex}-${innerIndex}` === activeAccordian
                            ? -1
                            : `${outerIndex}-${innerIndex}`
                        )
                      }
                      transition={{ duration: 1, delay: innerIndex * 0.01 }}
                      whileInView={{ opacity: [0, 1], y: [50, 0] }}
                    >
                      <div className={classes.topFiveHeader}>
                        <h3 className="font-20 font-wix-semibold">
                          {faq.title}
                        </h3>
                        <img
                          alt="Arrow"
                          className={clsx(
                            classes.downArrow,
                            `${outerIndex}-${innerIndex}` === activeAccordian &&
                              "active"
                          )}
                          src={downArrow}
                        />
                      </div>
                      <Collapse
                        className={classes.body}
                        in={activeAccordian === `${outerIndex}-${innerIndex}`}
                      >
                        <p className="font-18 font-wix-regular color-black2">
                          {faq.desc}
                        </p>
                      </Collapse>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={"Frequently asked questions - CRM for marketing team"}
        />
      </div>

      <DesignCrmCarousel backgroundImage={`url(${designbg})`} bgColor={""} />
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Best CRM for marketing teams to drive growth with confidence
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MarketingTeams;
